export default "__VITE_ASSET__4NlBh17C__"